import { useApp } from "../../model";
import { canISeeThis } from "../../utils";
import { ReactElement } from "react";
export default function AuthCheck(p: { alt?: ReactElement | null, authControl?: { rolesCanSee?: string[], rolesCanNotSee?: string[] }, children: any }) {
    const { currentUser } = useApp();
    const roles = currentUser?.roles || [];
    if (p.authControl) {
        return canISeeThis(roles, p.authControl) ? p.children : (
            p.alt === undefined ? <h1>对不起,您没有权限查看此页面</h1> : p.alt
        )
    } else {
        return p.children
    }
}